<template>
	<div class="common-cards">
		<section class="common-cards.head" data-aos="fade-right" @click="goTrade(data.title.slice(0,2))">
			<div class="common-cards.head.bg">
				<img :src="data.headBg" alt="">
			</div>
			<div class="common-cards.head.icon">
				<img :src="data.headIcon" alt="">
			</div>
			<div class="common-cards.head.text">
				<h2><span>{{data.title.slice(0,2)}}</span><small>类</small></h2>
				<h3>{{data.title.slice(4)}}</h3>
				<h4>{{data.desc}}</h4>
			</div>
		</section>
		<section class="common-cards.content" data-aos="fade-left">
			<div class="common-cards.triangle"><img :src="data.triangle" alt=""></div>
			<div class="common-cards.box" :style="{borderColor: data.borderColor }">
				<a href="javascript:;" v-for="(tab,index) in tabs" :key="index" target="_blank" @click="goTradeDetail(tab.id)">
					<img :src="imgUrl + tab.image" alt="">
				</a>
			</div>
			<div class="common-cards.triangle"><img :src="data.triangleDown" alt=""></div>
		</section>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tabs: [{
						img: require('../assets/cards/cards-tab-1.png')
					}, {
						img: require('../assets/cards/cards-tab-2.png')
					}, {
						img: require('../assets/cards/cards-tab-3.png')
					},
					{
						img: require('../assets/cards/cards-tab-4.png')
					}, {
						img: require('../assets/cards/cards-tab-5.png')
					}, {
						img: require('../assets/cards/cards-tab-1.png')
					},
					{
						img: require('../assets/cards/cards-tab-2.png')
					}, {
						img: require('../assets/cards/cards-tab-3.png')
					}, {
						img: require('../assets/cards/cards-tab-4.png')
					},
					{
						img: require('../assets/cards/cards-tab-5.png')
					},
				]
			}
		},
		props: ['data'],
		mounted() {
			this.http.get(`/IPR_Trademark?&attribute_id=${this.data.id}`).then(res => {
				this.tabs = res.data.data.slice(0, 10)
			})
		},
		methods: {
			goTrade(index) {
				let id;
				if (index.indexOf("0") == 0) {
					id = index.slice(1)
				} else {
					id = index
				}
				// this.$router.push({
				//    path:'Trademark',
				//    query:{
				// 	   id:parseInt(id)
				//    }
				//   })
				let routeUrl = this.$router.resolve({
					path: 'Trademark',
					query: {
						id: parseInt(id)
					}
				});
				window.open(
				  location.pathname + "#" + routeUrl.resolved.fullPath,
				  "_blank"
				); //线上发布用
			},
			goTradeDetail(id){
				let routeUrl = this.$router.resolve({
					path: '/Trademark/' + id,
				});
				window.open(
				  location.pathname + "#" + routeUrl.resolved.fullPath,
				  "_blank"
				); //线上发布用
			}
		}
	}
</script>

<style lang="scss">
	%imgSize {
		display: block;
		width: 100%;
		object-fit: cover;
		object-position: center;
	}

	@include component(common-cards) {
		width: 1200px;
		margin: 0 auto;
		height: 340px;
		// border: 1px solid red;
		margin-top: 20px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;

		@include part(head) {
			width: 180px;
			height: 340px;
			position: relative;
			cursor: pointer;

			@include part(bg) {
				width: 100%;
				height: 100%;

				img {
					@extend %imgSize
				}

			}

			@include part(icon) {

				position: absolute;
				right: 0;
				bottom: 0;

				img {
					@extend %imgSize
				}
			}

			@include part(text) {
				width: 100%;
				padding: 0 23px;
				height: 150px;
				position: absolute;
				top: 29px;
				left: 0;
				color: #fff;

				// background: red;
				h2 {
					margin: 0;
					text-align: left;
					display: flex;
					justify-content: flex-start;
					position: relative;
					width: 68px;
					margin-bottom: 21px;

					span {
						display: flex;
						width: 48px;
						height: 48px;
						border: 3px solid rgba(255, 255, 255, 1);
						border-radius: 2px;
						justify-content: center;
						align-items: center;
						font-size: 26px;
					}

					small {
						font-size: 16px;
						position: absolute;
						bottom: 0;
						right: 0;
					}


				}

				h3 {
					margin: 0;
					font-size: 22px;
					text-align: left;
					position: relative;
					padding-bottom: 10px;

					&:before {
						content: '';
						display: inline-block;
						width: 50px;
						height: 3px;
						background: #fff;
						position: absolute;
						bottom: 0;
						left: 0;
					}
				}

				h4 {
					margin: 0;
					margin-top: 20px;
					text-align: left;
					font-size: 20px;
					color: #fff;
					opacity: 0.3;
					font-weight: normal;
				}
			}
		}

		@include part(content) {
			width: calc(100% - 180px);
			height: 100%;
			display: flex;
			flex-direction: column;
			// box-shadow:0px 0px 10px 0px rgba(0, 0, 0, 0.1);
			// margin-top: 10px;
			// border-top:2px solid rgba(246,73,70,1);
			// &:before{
			// 	content: '';
			// 	display: inline-block;
			// 	
			// }
		}

		@include part(triangle) {
			width: 14px;
			height: 10px;

			img {
				display: block;
				width: 100%;
				height: 100%;
			}

		}

		@include part(box) {
			width: 100%;
			height: 320px;
			box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
			border-top: 2px solid rgba(246, 73, 70, 1);
			display: flex;
			justify-content: flex-start;
			flex-wrap: wrap;
			background: #fff;

			a {
				display: inline-block;
				width: calc(100% / 5);
				height: 159px;
				display: flex;
				justify-content: center;
				align-items: center;
				border-right: 1px solid #F2F2F2;
				border-bottom: 1px solid #F2F2F2;
                padding:20px;
				img {
					display: block;
					width: 100%;
					height: 100%;
					object-fit: contain;
					object-position: center;
					//border: 1px solid red;
				}

				&:hover {
					box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

				}
			}
		}
	}
</style>
